import { css } from "@emotion/core";
export const style = {
    container: css `
    overflow: hidden;
  `,
    ul: css `
    padding: 0;
    margin: 0;
    list-style-type: none;
    overflow: hidden;
  `
};
